import { IdeptInfo } from "../types";
import { PatternMatch } from "project-config/utils/pattern-match";

export function searchDingtalkTree(
  data: IdeptInfo[],
  searchInput: string
): IdeptInfo[] {
  const _data = JSON.parse(JSON.stringify(data));
  const isLeaf = (item: IdeptInfo) => item.deptId === null;

  const filterDeptList = (data: IdeptInfo[]) => {
    if (!data || data.length === 0) return data;
    return data.filter((item: IdeptInfo) => {
      if (!isLeaf(item)) {
        const deptList = filterDeptList(item.deptList);
        if (!deptList.length) return false;
        item.deptList = deptList;
      }
      return !isLeaf(item) || PatternMatch.fuzzyMatch(item.name, searchInput);
    });
  };
  return filterDeptList(_data);
}
